import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-white overflow-hidden" data-id="element-126">
      <div className="pt-8 pb-10 md:pt-16 md:pb-20 px-5" data-id="element-127">
        <div className="max-w-4xl mx-auto text-center" data-id="element-128">
          <FadeIn data-id="element-129">
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-brand-navy leading-[1.1] mb-5 font-bold tracking-tight" data-id="element-130">
              Tu hijo no te reta, su cerebro se bloqueó.{' '}
              <span className="text-brand-orange" data-id="element-131">
                Traduce sus rabietas en calma en menos de 60 segundos
              </span>{' '}
              con el Método CVR.
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-132">
            <p className="font-sans text-base md:text-xl text-slate-700 leading-relaxed mb-6 max-w-3xl mx-auto" data-id="element-133">
              El sistema de 3 pasos que ayuda a madres a detener las luchas de
              poder en casa hoy mismo, sin gritos y sin sentir culpa después.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-134">
            <div className="relative w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-2xl mb-6" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/9fxVzxEetHWgZFMzQM1iFd/hero.jpg" alt="Madre conectando con su hijo en un momento de calma" className="object-cover w-full h-auto" data-id="element-136" />
            </div>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-137">
            <CTAButton mainText="SÍ, QUIERO EL KIT DIGITAL CALMA EN CASA" subText="⚡ Acceso inmediato al Sistema CVR por solo $7" href="#final-cta" data-id="element-138" />
          </FadeIn>
        </div>
      </div>
    </section>;
}